'use client';

import React, {FC, PropsWithChildren} from 'react';
import Image from 'next/image';

import styles from './styles.module.scss';

type AccordionProps = {
  id: number;
  title: string;
  open: boolean;
  handleClick: (id: number | null) => void;
};

const Accordion: FC<PropsWithChildren<AccordionProps>> = ({
  id,
  title,
  open,
  handleClick,
  children,
}) => {
  const panelId = `accordion-panel-${id}`;

  return (
    <div className={styles['accordion__item']}>
      {/*
       * A real <button> inside the heading rather than a clickable <div>: the
       * heading keeps the FAQ list navigable by heading, and the button gets
       * focus, Enter/Space and an announced expanded state for free.
       */}
      <h4 className={styles['accordion__item_title']}>
        <button
          type="button"
          className={styles['accordion__item_trigger']}
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => handleClick(id)}>
          {title}
          <span>
            {open ? (
              <Image
                src="/static/svg/arrow-blue-up.svg"
                alt="Close Accordion"
                width="11"
                height="7"
                unoptimized
              />
            ) : (
              <Image
                src="/static/svg/arrow-blue-down.svg"
                alt="Open Accordion"
                width="11"
                height="7"
                unoptimized
              />
            )}
          </span>
        </button>
      </h4>
      {open && (
        <div
          id={panelId}
          data-testid="open-content"
          className={styles['accordion__item_content']}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;
